import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addressesAPI } from '../api/address';
import { ICreateAddress } from '../types/Adresses';
import { custonSooner } from '../../../components/CustopmSooner';
import { useNavigate } from 'react-router-dom';
import { addressesAdapter } from '../libs/addressesAdapter';
import { useDispatch, useSelector } from 'react-redux';

import { get } from 'lodash';
import {
  setAddresses,
  setSelectedAddress,
} from '../../../store/slices/userAddresses';
import { captureApiError } from '../../../lib/sentry-utils';
import { userInfo } from '../../../store/selectors/user';
import {
  guestAddressFromPayload,
  saveGuestAddressPayload,
} from '../libs/addressStorage';

type CreateAddressResult =
  | { isGuest: true; body: ICreateAddress }
  | { isGuest: false };

export const useCreateAddress = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(userInfo);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (body: ICreateAddress): Promise<CreateAddressResult> => {
      if (!user.isAuth || !localStorage.getItem('token')) {
        return { isGuest: true, body };
      }

      await addressesAPI.createAddress(body);
      return { isGuest: false };
    },

    onSuccess: async result => {
      custonSooner.success('Адрес успешно добавлен!');

      if (result.isGuest) {
        const guestAddress = guestAddressFromPayload(result.body);
        saveGuestAddressPayload(result.body);
        dispatch(setAddresses([guestAddress]));
        dispatch(setSelectedAddress(guestAddress._id));
        navigate('/');
        return;
      }

      // ✅ Refetch addresses
      const res = await queryClient.fetchQuery({
        queryKey: ['addresses'],
        queryFn: async () => await addressesAPI.getAddresses(),
      });

      const adapted = addressesAdapter(get(res, 'data.addresses', []));

      if (adapted[0]._id) {
        dispatch(setSelectedAddress(adapted[0]._id));
      }

      // ✅ Navigate after selection
      navigate('/');
    },

    onError: (error: any) => {
      console.error('CreateAddress error:', JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
      captureApiError(error, '/api/addresses/create', 'POST');
      
      if (error?.response?.status === 401) {
        custonSooner.error('Необходимо войти в систему');
        navigate('/');
      } else {
        custonSooner.error(error?.response?.data?.message || error?.message || 'Что-то пошло не так');
      }
    },
  });

  return {
    creatAddress: mutateAsync,
    isPending,
  };
};
